import {register} from '@shopify/theme-sections';
import Swiper from 'swiper';

// TODO: Look through all sections and update to this.id where possible

const selectors = {
  target: '.feature-list--',
};

register('feature-list', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const targetSelector = document.querySelector(target);

    if (!targetSelector) { return; }

    const desktopItemCount = targetSelector.dataset.desktopItemRow;
    const mobileItemCount = targetSelector.dataset.mobileItemRow;
    const swiper = new Swiper(target, {
      slidesPerView: desktopItemCount,
      loop: true,
      freeMode: false,
      spaceBetween: 16,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: mobileItemCount,
        },
        790: {
          slidesPerView: desktopItemCount,
        }
      }
    });
  },

  onBlockSelect: (blockId) => {
    const id = blockId.detail.sectionId;
    const currentSlide = parseInt(blockId.target.dataset.swiperSlideIndex) + 1;
    const target = `${selectors.target}${id}`;
    const swiper = document.querySelector(target).swiper;
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`🤠 Slide to block ${currentSlide}`)
  },
});
